import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'
import {HTTP_STATUS_OK} from '../../../Constants'
import {
    QueryCRUDTypes,
    QueryKeyManager,
} from '../../../query-manager/QueryKeysManager'
import {QueryKeyTypes} from '../../../query-manager/QueryKeyTypes'
import {severityNotification} from '../../notification/NotificationConstant'
import {showNotification} from '../../notification/NotificationService'
import {
    createOrUpdateECG,
    getPageElectrocardiograms,
    getUserECGData,
} from '../ECGEndPoint'

export const useUserECG = (requestorId, userId, brand, enabled = true) => {
    const {ecgKeys} = QueryKeyManager(QueryKeyTypes.ecg, requestorId)
    return useQuery({
        queryKey: ecgKeys.detailByUser({userId, brand}),
        queryFn: () => getUserECGData(userId, brand),
        enabled: !!requestorId && !!userId && !!brand,
    })
}

export const usePageElectrocardiograms = (
    requestorId,
    pageNumber,
    pageRows,
    sortField,
    sortOrder,
    filterRequest,
    enabled = true,
) => {
    const {ecgKeys} = QueryKeyManager(QueryKeyTypes.ecg, requestorId)

    return useQuery({
        queryKey: ecgKeys.page({
            pageNumber,
            pageRows,
            sortField,
            sortOrder,
            filterRequest,
        }),
        queryFn: () =>
            getPageElectrocardiograms(
                requestorId,
                pageNumber,
                pageRows,
                sortField,
                sortOrder,
                filterRequest,
            ),
        enabled: !!requestorId && !!enabled,
    })
}

export const useElectrocardiogramCRUD = (type, requestorId) => {
    const {ecgKeys} = QueryKeyManager(QueryKeyTypes.ecg, requestorId)
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: data =>
            type === QueryCRUDTypes.create || type === QueryCRUDTypes.update
                ? createOrUpdateECG(requestorId, data)
                : data,
        onSuccess: (data, variables) => {
            // Data is the response from the server
            // Variables is the data that was passed to the mutationFn
            if (data === HTTP_STATUS_OK || data?.id) {
                if (
                    type === QueryCRUDTypes.create ||
                    type === QueryCRUDTypes.update
                ) {
                    showNotification(
                        severityNotification.success,
                        'Electrocardiogram Update Successfully !!',
                    )
                }
            }
        },
    })
}
